<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Edit Schedule {{title}}</v-card-title>

        <v-card-text>
            <m-daily-schedule
                v-model="value"
                :read_only="false"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Save
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    props: {

        title: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            dialog: false,
            value: null,
            on_save: null,
        }
    },

    methods: {

        showDialog(value, on_save)
        {
            this.value = _.cloneDeep(value);
            this.on_save = on_save;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.on_save(this.value);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>